
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
    data() {
        return {};
    },
    setup() {
        const router = useRouter();
        return {
            active: computed(
                () => router.currentRoute.value.meta.tabbarActive || "home"
            ),
        };
    },
    // mounted() {},
    methods: {
        goPage(url: string) {
            this.$router.push(url);
        },
    },
});
